export function addGoogleTagEvent(event: string, variables: object = {}) {
  window.dataLayer.push({
    event,
    ...variables,
  });
}
